"use strict";

var _regeneratorRuntime = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@netgum/utils");

var Device = /*#__PURE__*/function () {
  function Device(state, storage) {
    _classCallCheck(this, Device);

    this.state = state;
    this.storage = storage;
    this.privateKey = null; //
  }

  _createClass(Device, [{
    key: "setup",
    value: function setup() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var privateKey;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!options.privateKey) {
                  _context.next = 6;
                  break;
                }

                privateKey = utils_1.anyToBuffer(options.privateKey, {
                  defaults: null
                });

                if (!utils_1.verifyPrivateKey(privateKey)) {
                  _context.next = 6;
                  break;
                }

                this.privateKey = privateKey;
                _context.next = 6;
                return this.storage.setItem(Device.StorageKeys.PrivateKey, this.privateKey);

              case 6:
                if (this.privateKey) {
                  _context.next = 10;
                  break;
                }

                _context.next = 9;
                return this.storage.getItem(Device.StorageKeys.PrivateKey);

              case 9:
                this.privateKey = _context.sent;

              case 10:
                if (this.privateKey) {
                  _context.next = 13;
                  break;
                }

                _context.next = 13;
                return this.generatePrivateKey();

              case 13:
                this.emitState();

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "reset",
    value: function reset() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.generatePrivateKey();

              case 2:
                this.emitState();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "signPersonalMessage",
    value: function signPersonalMessage(message) {
      return utils_1.signPersonalMessage(message, this.privateKey);
    }
  }, {
    key: "generatePrivateKey",
    value: function generatePrivateKey() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.privateKey = utils_1.generateRandomPrivateKey();
                _context3.next = 3;
                return this.storage.setItem(Device.StorageKeys.PrivateKey, this.privateKey);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "emitState",
    value: function emitState() {
      var address = utils_1.privateKeyToAddress(this.privateKey);
      this.state.device$.next({
        address: address
      });
    }
  }]);

  return Device;
}();

exports.Device = Device;

(function (Device) {
  var StorageKeys;

  (function (StorageKeys) {
    StorageKeys["PrivateKey"] = "private_key";
  })(StorageKeys = Device.StorageKeys || (Device.StorageKeys = {}));
})(Device = exports.Device || (exports.Device = {}));